/* eslint-disable max-len */
export const validateCellphone = (value: string): boolean => {
  if (!value) return false;
  const cleaned = value.replace(/\D/g, '');
  return cleaned.length === 11;
};

export const formatPhoneNumber = (input: string): string => {
  // Remove tudo que não for número
  const onlyDigits = input.replace(/\D/g, '');

  // Remove o DDI se o usuário digitar por conta (ex: 55669911122334 vira 66991122334)
  const digits = onlyDigits.startsWith('55') ? onlyDigits.slice(2) : onlyDigits;

  // Aplica o formato: (XX) XXXXX-XXXX
  const regex = /^(\d{2})(\d{5})(\d{0,4})$/;
  const regex2 = /^(\d{2})(\d{4})(\d{0,4})$/;

  const match = regex.exec(digits) || regex2.exec(digits);

  if (match) {
    const [, ddd, firstPart, secondPart] = match;
    return `+55 (${ddd}) ${firstPart}-${secondPart}`.trim().replace(/-$/, '');
  }

  if (digits.length <= 2) return `+55 (${digits}`;
  if (digits.length <= 7) return `+55 (${digits.slice(0, 2)}) ${digits.slice(2)}`;
  return `+55 (${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
};

